import React, { useState, useEffect } from "react";
import "../styles/theme-dark.css";
import "./EmailSettings.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

/* ---------------------------------------------------------
   FUNCIÓN GLOBAL PARA CAMBIAR EL TAMAÑO DEL LOGO EN QUILL
------------------------------------------------------------ */
function updateGlobalLogoHeight(px) {
  const styleId = "logo-size-style";
  let tag = document.getElementById(styleId);

  if (!tag) {
    tag = document.createElement("style");
    tag.id = styleId;
    document.head.appendChild(tag);
  }

  tag.innerHTML = `
    .email-section .ql-editor img {
      height: ${px}px !important;
      width: auto !important;
    }
  `;
}

/* ---------------------------------------------------------
   API
------------------------------------------------------------ */
const API = "/api";


/* ---------------------------------------------------------
   CONFIGURACIÓN QUILL
------------------------------------------------------------ */
const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    [{ font: [] }],
    [{ size: ["small", false, "large", "huge"] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"], // IMAGEN DESACTIVADA PARA EVITAR CUELGUES
    ["clean"]
  ]
};

/* ---------------------------------------------------------
   COMPONENTE PRINCIPAL
------------------------------------------------------------ */
export default function EmailSettings() {
  const [settings, setSettings] = useState(null);
  const [activeTab, setActiveTab] = useState("smtp");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  /* ---------------------------------------------------------
     CARGAR AJUSTES
  ------------------------------------------------------------ */
  async function loadSettings() {
    try {
      const res = await fetch(`${API}/email-settings`);
      const json = await res.json();

      const raw = json.data || json || {};

      const mapped = {
        // SMTP
        smtp_host: raw.smtp_host || raw.host || "",
        smtp_port: raw.smtp_port || raw.port || 587,
        smtp_user: raw.smtp_user || raw.user || "",
        smtp_pass: raw.smtp_pass || raw.pass || "",
        smtp_from: raw.smtp_from || raw.from || "",
        smtp_secure:
          typeof raw.smtp_secure === "boolean"
            ? raw.smtp_secure
            : typeof raw.secure === "boolean"
            ? raw.secure
            : false,
        smtp_starttls:
          typeof raw.smtp_starttls === "boolean"
            ? raw.smtp_starttls
            : true,

        // IMAP
        imap_host: raw.imap_host || raw.smtp_host || raw.host || "",
        imap_port: raw.imap_port || 143,
        imap_secure:
          typeof raw.imap_secure === "boolean" ? raw.imap_secure : false,
        imap_user: raw.imap_user || raw.smtp_user || raw.user || "",
        imap_pass: raw.imap_pass || raw.smtp_pass || raw.pass || "",

        // PLANTILLAS
        asunto_presupuesto: raw.asunto_presupuesto || "",
        plantilla_presupuesto: raw.plantilla_presupuesto || "",
        asunto_factura: raw.asunto_factura || "",
        plantilla_factura: raw.plantilla_factura || "",

        // FIRMA
        emailFooterHtml: raw.emailFooterHtml || "",
        logoHeight: raw.logoHeight || ""
      };

      setSettings(mapped);
    } catch (err) {
      console.error("Error cargando ajustes:", err);
    }
  }

  /* ---------------------------------------------------------
     GUARDAR AJUSTES
  ------------------------------------------------------------ */
  async function save() {
    if (!settings) return;

    setSaving(true);

    const payload = {
      // SMTP
      smtp_host: settings.smtp_host,
      smtp_port: Number(settings.smtp_port || 0),
      smtp_secure: !!settings.smtp_secure,
      smtp_starttls: !!settings.smtp_starttls,
      smtp_user: settings.smtp_user,
      smtp_pass: settings.smtp_pass,
      smtp_from: settings.smtp_from,

      // IMAP
      imap_host: settings.imap_host,
      imap_port: Number(settings.imap_port || 0),
      imap_secure: !!settings.imap_secure,
      imap_user: settings.imap_user,
      imap_pass: settings.imap_pass,

      // PLANTILLAS
      asunto_presupuesto: settings.asunto_presupuesto,
      plantilla_presupuesto: settings.plantilla_presupuesto,
      asunto_factura: settings.asunto_factura,
      plantilla_factura: settings.plantilla_factura,

      // FIRMA
      emailFooterHtml: settings.emailFooterHtml,
      logoHeight: settings.logoHeight
    };

    try {
      let res = await fetch(`${API}/email-settings`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        res = await fetch(`${API}/email-settings`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
      }

      setSaving(false);

      if (res.ok) {
        alert("Ajustes guardados correctamente.");
        loadSettings();
      } else {
        alert("Error al guardar ajustes.");
      }
    } catch (err) {
      console.error("Error guardando ajustes:", err);
      setSaving(false);
      alert("Error de comunicación con el servidor.");
    }
  }

  /* ---------------------------------------------------------
     RENDER
  ------------------------------------------------------------ */
  if (!settings) {
    return (
      <div className="page-dark" style={{ padding: 40 }}>
        Cargando ajustes…
      </div>
    );
  }

  return (
    <div className="page-dark" style={{ padding: 40 }}>
      <h1>Ajustes de Email</h1>

      {/* TABS */}
      <div className="email-tabs">
        {["smtp", "imap", "plantillas", "pie"].map((tab) => (
          <div
            key={tab}
            className={`email-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab === "pie"
              ? "PIE DE FIRMA"
              : tab === "imap"
              ? "IMAP"
              : tab.toUpperCase()}
          </div>
        ))}
      </div>

      <div className="email-card glass-box">

        {/* ---------------------------------------------------------
           PIE DE FIRMA
        ------------------------------------------------------------ */}
        {activeTab === "pie" && (
          <div className="email-section">
            <h2>Pie de firma</h2>

            {/* Vista previa */}
            <div
              style={{
                marginBottom: 15,
                padding: 12,
                background: "#ffffff10",
                borderRadius: 8
              }}
            >
              <strong>Logo actual:</strong>
              <br />
              <img
                src="/uploads/logos/logo_1.png"
                alt="logo"
                style={{ height: 60, marginTop: 8 }}
              />
            </div>

            {/* Botones inserción */}
            <div
              style={{
                padding: 12,
                background: "#ffffff10",
                borderRadius: 8,
                marginBottom: 15
              }}
            >
              <strong>Insertar logo:</strong>

              <div style={{ marginTop: 10, display: "flex", gap: 10 }}>
                {/* 60px */}
                <button
                  className="glass-btn"
                  onClick={() => {
                    const html =
                      (settings.emailFooterHtml || "") +
                      `<br><img src="/uploads/logos/logo_1.png" style="height:60px;width:auto;">`;

                    updateGlobalLogoHeight(60);
                    setSettings(prev => ({ ...prev, emailFooterHtml: html }));
                  }}
                >
                  60px
                </button>

                {/* 40px */}
                <button
                  className="glass-btn"
                  onClick={() => {
                    const html =
                      (settings.emailFooterHtml || "") +
                      `<br><img src="/uploads/logos/logo_1.png" style="height:40px;width:auto;">`;

                    updateGlobalLogoHeight(40);
                    setSettings(prev => ({ ...prev, emailFooterHtml: html }));
                  }}
                >
                  40px
                </button>

                {/* 80px */}
                <button
                  className="glass-btn"
                  onClick={() => {
                    const html =
                      (settings.emailFooterHtml || "") +
                      `<br><img src="/uploads/logos/logo_1.png" style="height:80px;width:auto;">`;

                    updateGlobalLogoHeight(80);
                    setSettings(prev => ({ ...prev, emailFooterHtml: html }));
                  }}
                >
                  80px
                </button>
              </div>

              {/* PERSONALIZADO */}
              <div style={{ marginTop: 10 }}>
                <label>Personalizado (px):</label>

                <input
                  type="number"
                  className="glass-input"
                  placeholder="Ej: 75"
                  value={settings.logoHeight || ""}
                  onChange={(e) => {
                    const h = e.target.value;
                    setSettings(prev => ({ ...prev, logoHeight: h }));
                  }}
                  style={{ width: 120, marginLeft: 10 }}
                />

                <button
                  className="glass-btn"
                  style={{ marginLeft: 10 }}
                  onClick={() => {
                    const h = settings.logoHeight || 60;

                    const html =
                      (settings.emailFooterHtml || "") +
                      `<br><img src="uploads/logos/logo_1.png" style="height:${h}px;width:auto;">`;

                    updateGlobalLogoHeight(h);

                    setSettings(prev => ({ ...prev, emailFooterHtml: html }));
                  }}
                >
                  Insertar
                </button>
              </div>
            </div>

            {/* EDITOR */}
            <ReactQuill
              theme="snow"
              modules={quillModules}
              value={settings.emailFooterHtml}
              onChange={(html) =>
                setSettings({
                  ...settings,
                  emailFooterHtml: html
                })
              }
              style={{
                background: "white",
                color: "black",
                borderRadius: "8px",
                minHeight: "220px"
              }}
            />

            <p style={{ opacity: 0.5, fontSize: 12, marginTop: 10 }}>
              Inserta el logo con tamaño inline. El sistema lo enviará como CID.
            </p>
          </div>
        )}

        {/* ---------------------------------------------------------
           SMTP / IMAP / PLANTILLAS (NO LOS CAMBIO)
        ------------------------------------------------------------ */}
        
        {activeTab === "smtp" && (
          <div className="email-section">
            <h2>Servidor SMTP (salida)</h2>

            <div className="grid-2">
              <div>
                <label>Host</label>
                <input
                  className="glass-input"
                  value={settings.smtp_host}
                  onChange={(e) =>
                    setSettings({ ...settings, smtp_host: e.target.value })
                  }
                />
              </div>

              <div>
                <label>Puerto</label>
                <input
                  type="number"
                  className="glass-input"
                  value={settings.smtp_port}
                  onChange={(e) =>
                    setSettings({ ...settings, smtp_port: e.target.value })
                  }
                />
              </div>

              <div>
                <label>Usuario</label>
                <input
                  className="glass-input"
                  value={settings.smtp_user}
                  onChange={(e) =>
                    setSettings({ ...settings, smtp_user: e.target.value })
                  }
                />
              </div>

              <div>
                <label>Contraseña</label>
                <input
                  type="password"
                  className="glass-input"
                  value={settings.smtp_pass}
                  onChange={(e) =>
                    setSettings({ ...settings, smtp_pass: e.target.value })
                  }
                />
              </div>

              <div>
                <label>Correo remitente</label>
                <input
                  className="glass-input"
                  value={settings.smtp_from}
                  onChange={(e) =>
                    setSettings({ ...settings, smtp_from: e.target.value })
                  }
                />
              </div>

              <div>
                <label>Seguro (SSL/TLS)</label>
                <select
                  className="glass-input"
                  value={settings.smtp_secure ? "1" : "0"}
                  onChange={(e) =>
                    setSettings({
                      ...settings,
                      smtp_secure: e.target.value === "1"
                    })
                  }
                >
                  <option value="1">Sí</option>
                  <option value="0">No</option>
                </select>
              </div>

              <div>
                <label>Usar STARTTLS</label>
                <select
                  className="glass-input"
                  value={settings.smtp_starttls ? "1" : "0"}
                  onChange={(e) =>
                    setSettings({
                      ...settings,
                      smtp_starttls: e.target.value === "1"
                    })
                  }
                >
                  <option value="1">Sí</option>
                  <option value="0">No</option>
                </select>
              </div>
            </div>
          </div>
        )}

        {activeTab === "imap" && (
          <div className="email-section">
            <h2>Servidor IMAP (entrada)</h2>

            <div className="grid-2">
              <div>
                <label>Host</label>
                <input
                  className="glass-input"
                  value={settings.imap_host}
                  onChange={(e) =>
                    setSettings({ ...settings, imap_host: e.target.value })
                  }
                />
              </div>

              <div>
                <label>Puerto</label>
                <input
                  type="number"
                  className="glass-input"
                  value={settings.imap_port}
                  onChange={(e) =>
                    setSettings({ ...settings, imap_port: e.target.value })
                  }
                />
              </div>

              <div>
                <label>Usuario</label>
                <input
                  className="glass-input"
                  value={settings.imap_user}
                  onChange={(e) =>
                    setSettings({ ...settings, imap_user: e.target.value })
                  }
                />
              </div>

              <div>
                <label>Contraseña</label>
                <input
                  type="password"
                  className="glass-input"
                  value={settings.imap_pass}
                  onChange={(e) =>
                    setSettings({ ...settings, imap_pass: e.target.value })
                  }
                />
              </div>

              <div>
                <label>Seguro (SSL/TLS)</label>
                <select
                  className="glass-input"
                  value={settings.imap_secure ? "1" : "0"}
                  onChange={(e) =>
                    setSettings({
                      ...settings,
                      imap_secure: e.target.value === "1"
                    })
                  }
                >
                  <option value="1">Sí</option>
                  <option value="0">No</option>
                </select>
              </div>
            </div>
          </div>
        )}

        {activeTab === "plantillas" && (
          <div className="email-section">
            <h2>Plantillas</h2>

            <h3>Presupuestos</h3>
            <label>Asunto</label>
            <input
              className="glass-input"
              value={settings.asunto_presupuesto}
              onChange={(e) =>
                setSettings({
                  ...settings,
                  asunto_presupuesto: e.target.value
                })
              }
            />

            <label>Mensaje</label>
            <textarea
              className="glass-input"
              rows={5}
              value={settings.plantilla_presupuesto}
              onChange={(e) =>
                setSettings({
                  ...settings,
                  plantilla_presupuesto: e.target.value
                })
              }
            />

            <h3 style={{ marginTop: 30 }}>Facturas</h3>
            <label>Asunto</label>
            <input
              className="glass-input"
              value={settings.asunto_factura}
              onChange={(e) =>
                setSettings({
                  ...settings,
                  asunto_factura: e.target.value
                })
              }
            />

            <label>Mensaje</label>
            <textarea
              className="glass-input"
              rows={5}
              value={settings.plantilla_factura}
              onChange={(e) =>
                setSettings({
                  ...settings,
                  plantilla_factura: e.target.value
                })
              }
            />
          </div>
        )}
      </div>

      {/* BOTÓN GUARDAR */}
      <button className="glass-btn primary" onClick={save} disabled={saving}>
        {saving ? "Guardando…" : "Guardar cambios"}
      </button>
    </div>
  );
}
